import { ReactElement, useEffect, useState } from 'react';
import apiServices from '../../services/apiServices';

interface Props {
  post_id: number;
  attachment: any;
}

function PostAttachment({ post_id, attachment }: Props): ReactElement {
  const fileName = decodeURIComponent(attachment.name);
  const [file, setFile] = useState<File>();

  useEffect(() => {
    if (!post_id || !attachment) {
      return
    }
    apiServices.getAttachment(post_id, attachment.id).then(blob => {
      const obj = new File([blob], fileName, { type: blob.type });
      setFile(obj);
    }).catch(e => {
      //TODO 画像を取得できない場合に代わりに表示したい画像はあるか？
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post_id, attachment]);

  return (
    <p
      dangerouslySetInnerHTML={{
        __html: file
          ? `<a href="${URL.createObjectURL(file)}" download="${fileName}" rel="noopener noreferrer">${fileName}</a>`
          : fileName,
      }}
      style={{margin: "5px 0"}}
    >
    </p>
  );
};

export default PostAttachment;
